<template>
  <div class="Productdetail">
    <div class="wrapper-content">
      <div class="container productDetailsPage">
        <div class="product-right">
          <div class="row">
            <div class="col-md-5 col-sm-12">
              <div class="slide_bx panel">
                <img :src="imageBaseUrl+ details.image" />
              </div>
            </div>
            <div class="col-md-7 col-sm-12">
              <div class="panel">
                <h2>{{details.name}}</h2>
                <div
                  class="price"
                  v-if="details.price_per_unit"
                >{{currency}}{{details.price_per_unit.toFixed(2)}}/ {{details.unit.name}} ({{currency}}{{details.mrp_single.toFixed(2)}})</div>
                <p class="subParagraph">{{details.description}}</p>
                <div class="line"></div>
                <div class="quantity" v-if="openDaysBox">
                  <div class="row">
                    <div class="col-md-12">
                      <b-form-input
                        @click="$bvModal.show('addDeliveryAddress')"
                        v-model="selectedAdd"
                        readonly
                        :placeholder="$t('message.DelAddress')"
                      >
                        <img src="../assets/images/next.svg" />
                      </b-form-input>

                      <b-modal id="addDeliveryAddress">
                        <template v-slot:modal-title>
                          Delivery Address
                          <div class="addNewAddress">
                            <router-link
                              to="/add-new-address"
                              class="btn btn-primary"
                            >Add New Address</router-link>
                          </div>
                        </template>

                        <div class="deliveryAddressList">
                          <ul>
                            <div class="radiobtn">
                              <b-form-radio-group
                                id="radio-group-2"
                                v-model="selectAddress"
                                name="radio-sub-component"
                              >
                                <b-form-radio
                                  v-for="(item,index) in addresses"
                                  :key="index"
                                  :value="item.id"
                                >
                                  {{item.address.title.toUpperCase()}}
                                  <br />
                                  {{item.address.address}},{{item.address.location}}
                                </b-form-radio>
                              </b-form-radio-group>
                              <!-- <b-form-radio-group
                                  id="btn-radios-2"
                                  v-model="selectAddress"
                                  :options="deliveryAddress "
                                  name="radio-btn-outline"
                              ></b-form-radio-group>-->
                            </div>
                          </ul>
                        </div>
                        <template v-slot:modal-footer>
                          <button
                            class="btn btn-primary"
                            v-on:click="getDays(selectAddress)"
                          >{{ $t('message.Ok') }}</button>
                        </template>
                      </b-modal>
                      <div v-if="selectAddress">
                        <b-button v-on:click="isDaily=true ,isAlternate=false,isCustom=false">Daily</b-button>
                        <b-button
                          v-on:click="isDaily=false ,isAlternate=true,isCustom=false"
                        >Alternate</b-button>
                        <b-button v-on:click="isDaily=false ,isAlternate=false,isCustom=true">Custom</b-button>
                      </div>
                      <div class="quantity" v-if="isDaily">
                        <ul>
                          <li v-for="(item,index) in setDays" :key="index">
                            <label class="cust" v-if="item.day==1">{{ $t('message.Monday') }}</label>
                            <label class="cust" v-if="item.day==2">{{ $t('message.Tuesday') }}</label>
                            <label class="cust" v-if="item.day==3">{{ $t('message.Wednesday') }}</label>
                            <label class="cust" v-if="item.day==4">{{ $t('message.Thursday') }}</label>
                            <label class="cust" v-if="item.day==5">{{ $t('message.Friday') }}</label>
                            <label class="cust" v-if="item.day==6">{{ $t('message.Saturday') }}</label>
                            <label class="cust" v-if="item.day==7">{{ $t('message.Sunday') }}</label>
                            <div class="qty_dv">
                              <b-input-group>
                                <b-input-group-prepend>
                                  <b-btn variant="info" @click="quantityDaily--">-</b-btn>
                                </b-input-group-prepend>
                                <b-form-input type="number" min="0" v-model="quantityDaily"></b-form-input>
                                <b-input-group-append>
                                  <b-btn variant="info" @click="quantityDaily++">+</b-btn>
                                </b-input-group-append>
                              </b-input-group>
                            </div>
                          </li>
                        </ul>
                      </div>
                      <div class="quantity" v-if="isAlternate">
                        <ul>
                          <li>
                            <label class="cust">{{ $t('message.SelectQuantity') }}</label>

                            <div class="qty_dv">
                              <b-input-group>
                                <b-input-group-prepend>
                                  <b-btn variant="info" @click="quantityAlternate--">-</b-btn>
                                </b-input-group-prepend>
                                <b-form-input type="number" min="0" v-model="quantityAlternate"></b-form-input>
                                <b-input-group-append>
                                  <b-btn variant="info" @click="quantityAlternate++">+</b-btn>
                                </b-input-group-append>
                              </b-input-group>
                            </div>
                          </li>
                        </ul>
                      </div>
                      <div class="quantity" v-if="isCustom">
                        <ul>
                          <li v-for="(item,index) in setDays" :key="index">
                            <label class="cust" v-if="item.day==1">{{ $t('message.Monday') }}</label>
                            <label class="cust" v-if="item.day==2">{{ $t('message.Tuesday') }}</label>
                            <label class="cust" v-if="item.day==3">{{ $t('message.Wednesday') }}</label>
                            <label class="cust" v-if="item.day==4">{{ $t('message.Thursday') }}</label>
                            <label class="cust" v-if="item.day==5">{{ $t('message.Friday') }}</label>
                            <label class="cust" v-if="item.day==6">{{ $t('message.Saturday') }}</label>
                            <label class="cust" v-if="item.day==7">{{ $t('message.Sunday') }}</label>
                            <div class="qty_dv">
                              <b-input-group>
                                <b-input-group-prepend>
                                  <b-btn variant="info" @click="item.quantity--">-</b-btn>
                                </b-input-group-prepend>
                                <b-form-input type="number" min="0" v-model="item.quantity"></b-form-input>
                                <b-input-group-append>
                                  <b-btn variant="info" @click="item.quantity++">+</b-btn>
                                </b-input-group-append>
                              </b-input-group>
                            </div>
                          </li>
                        </ul>
                      </div>
                    </div>
                  </div>
                  <div
                    class="error"
                    v-if="!selectedAdd && nextStatus"
                  >{{ $t('message.AddressValidation') }}</div>
                  <div
                    class="error"
                    v-else-if="(isCustom==false&&isDaily==false&&isAlternate==false) && nextStatus"
                  >{{ $t('message.QuantityValidation') }}</div>
                  <div class="btn_rw">
                    <b-button id="confirm" class="btn btn-primary" v-on:click="openSchedules">Next</b-button>
                  </div>
                </div>
                <div class="quantity" v-if="openScheduleBox">
                  <div class="subscribe_bx" id="subs_bx">
                    <div class="border listbox">
                      <div class="row">
                        <div class="col-md-12">
                          <div class="selectDatePicker">
                            <h4>Select Start Date</h4>
                            <p>{{ showDateModal }}</p>
                            <datepicker
                              ref="programaticOpen"
                              v-model="showDateModal"
                              :format="customFormatter"
                              :disabled-dates="disabledDates"
                              @selected="setDate"
                            ></datepicker>
                            <button class="calendarBtn" @click="openPicker">
                              <i class="fa fa-calendar"></i>
                            </button>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div class="border listbox" @click="$bvModal.show('deiverySchedule')">
                      <div class="row">
                        <div class="col-md-12">
                          <h4>Select Delivery Schedule</h4>
                          {{selectedSchedule}}
                          <span class="clockIcon">
                            <img src="../assets/images/fast.svg" />
                          </span>
                        </div>
                      </div>
                    </div>
                    <div class="quantity">
                      <div>
                        <div class="row">
                          <div class="col-md-12" @click="$bvModal.show('addDeliveries')">
                            <!-- <p class="addressSelectBtn"> -->
                            <!-- Select Deliveries -->
                            <b-form-input
                              disabled
                              v-model="selectedDays"
                              placeholder="Select Deliveries"
                            ></b-form-input>

                            <img class="nextIconImg" src="../assets/images/next.svg" />
                            <!-- </p> -->
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="btn_rw">
                    <b-button id="confirm" class="btn btn-primary">Confirm</b-button>
                    <b-button
                      id="confirm"
                      class="btn btn-primary"
                      v-on:click="openDaysBox =true,openScheduleBox=false"
                    >Previous</b-button>
                  </div>
                  <b-modal id="deiverySchedule">
                    <template v-slot:modal-title>Select Delivery Schedule</template>

                    <div class="deliveryAddressList">
                      <ul>
                        <div class="radiobtn">
                          <b-form-radio-group
                            id="btn-radios-2"
                            v-model="selectedSchedule"
                            :options="deliverySchedules"
                            name="radio-btn-outline"
                          ></b-form-radio-group>
                        </div>
                      </ul>
                    </div>
                    <template v-slot:modal-footer>
                      <b-button @click="$bvModal.hide('deiverySchedule')">Ok</b-button>
                    </template>
                  </b-modal>
                  <b-modal id="confirmActivation" hide-header>
                    Do you want to Activate the subscription?
                    <template v-slot:modal-footer>
                      <b-button @click="gotoPayments()">Yes</b-button>
                      <b-button @click="$bvModal.hide('confirmActivation')">No</b-button>
                    </template>
                  </b-modal>
                  <b-modal id="addDeliveries">
                    <template v-slot:modal-title>I Want</template>

                    <div class="deliveryAddressList">
                      <ul>
                        <div class="radiobtn">
                          <b-form-radio-group
                            id="btn-radios-1"
                            v-model="selectedDelivery"
                            :options="getDeliveries"
                            name="radio-btn-outline"
                          ></b-form-radio-group>
                        </div>
                      </ul>
                    </div>
                    <template v-slot:modal-footer>
                      <b-button v-on:click="onSelectDeliveries()">Ok</b-button>
                    </template>
                  </b-modal>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Vue from "vue";
import Datepicker from "vuejs-datepicker";
import {
  getDeliveryDuration,
  getBalanceAndDeliveryInfo,
  getProductDetail,
  getdaysByArea,
  getDeliveryChargeInfo,
  getDeliveries
} from "./../services/api";
import moment from "moment";
import Vuelidate from "vuelidate";
import { required, email } from "vuelidate/lib/validators";

Vue.use(Vuelidate);

export default {
  components: {
    Datepicker
  },
  validations: {
    selectedAdd: {
      required
    }
  },
  data() {
    return {
      currency: localStorage.getItem("CurrencySymbol"),
      imageBaseUrl: "https://trakop.s3.amazonaws.com/",
      format: "dd MMMM yyyy",
      disabledDates: {
        to: new Date(),
        days: []
      },
      getDeliveries: [],
      showDateModal: null,
      quantityDaily: 1,
      quantityAlternate: 1,
      addresses: "",
      selectAddress: "",
      selectedAdd: "",
      deliveryAddress: [],
      deliverySchedules: [],
      details: "",
      setDays: [],
      isDaily: false,
      isAlternate: false,
      isCustom: false,
      openScheduleBox: false,
      openDaysBox: true,
      selectedDelivery: "",
      selectedDays: "",
      selectedSchedule: "",
      nextStatus: false
    };
  },
  created() {
    this.getAddressInfo();
    this.getDuration();
    if (!localStorage.getItem("userName")) {
      localStorage.clear();
      this.$router.push({ name: "register" });
    } else {
      this.getDetails();
    }
  },
  methods: {
    customDates() {},
    openSchedules() {
      if (
        this.$v.$invalid ||
        (this.isDaily == false &&
          this.isAlternate == false &&
          this.isCustom == false)
      ) {
        this.nextStatus = true;
      } else {
        for (var i = 0; i < this.setDays.length; i++) {
          if (this.setDays[i].quantity == 0) {
            this.disabledDates.days.push(this.setDays[i].day);
          }
        }
        this.openScheduleBox = true;
        this.openDaysBox = false;
      }
    },
    customFormatter(date) {
      return moment(date).format("MMMM DD YYYY");
    },
    addDays(date, days) {
      const copy = new Date(Number(date));
      copy.setDate(date.getDate() + days);
      return copy;
    },
    onSelectDeliveries() {
      this.$bvModal.hide("addDeliveries");
      console.log("setDays", this.setDays);
      var dy = this.daysDetails.filter(
        item => item.id == this.selectedDelivery
      );
      var dayName = "";
      if (dy[0].name == "Day") {
        dayName = "Delivery";
      } else {
        dayName = "Deliveries";
      }
      this.selectedDays = dy[0].duration + " " + dayName;
      var endDate = this.addDays(this.showDateModal, dy[0].duration);
      var start = moment(this.showDateModal),
        end = moment(endDate),
        day = "";
      var totalQuantity = 0;
      for (var i = 0; i < this.setDays.length; i++) {
        if (this.setDays[i].day == 1) {
          var monday = [];
          var current = start.clone();

          while (current.day(7 + 1).isBefore(end)) {
            monday.push(current.clone());
          }
          totalQuantity =
            totalQuantity + monday.length * this.setDays[i].quantity;
         console.log("totalQuantity",totalQuantity)
        }
      }
    },
    setDate(date) {
      if (date) {
        this.getDeliverySchedule(moment(date).format("YYYY-MM-DD"));
      }
    },
    openPicker() {
      this.$refs.programaticOpen.showCalendar();
    },
    getDays(selected) {
      this.$bvModal.hide("addDeliveryAddress");

      var pp = this.addresses.filter(item => item.id == selected);

      this.selectedAdd =
        pp[0].title.toUpperCase() +
        ":- " +
        pp[0].address.address +
        "," +
        pp[0].address.location;

      var requestData = {
        area_id: pp[0].area_id,
        user_id: localStorage.getItem("userId"),
        token: localStorage.getItem("token"),
        vendor_id: localStorage.getItem("vendorId")
      };

      getdaysByArea(requestData)
        .then(result => {
          if (result.data.successCode === 1) {
            for (var i = 0; i < result.data.data.areaDay.length; i++) {
              this.setDays.push({
                area_day_id: result.data.data.areaDay[i].area_day_id,
                day: result.data.data.areaDay[i].day,
                status: result.data.data.areaDay[i].status,
                quantity: 1
              });
            }
            console.log("werw", this.setDays);
          } else if (
            result.data.successCode === 0 &&
            result.data.messageCode === 1053
          ) {
            localStorage.clear();
            this.$router.replace({ name: "register" });
          }
        })
        .catch(error => {
          return;
        });
    },
    getDeliverySchedule(selectDate) {
      if (!localStorage.getItem("userName")) {
        localStorage.clear();
        this.$router.push({ name: "register" });
      } else {
        var requestData = {
          user_id: localStorage.getItem("userId"),
          vendor_id: localStorage.getItem("vendorId"),
          token: localStorage.getItem("token"),
          category_id: this.details.category_id,
          address_id: this.details.user_address_id,
          product_id: this.details.productId,
          selected_date: selectDate
        };
        getDeliveries(requestData)
          .then(result => {
            if (result.data.successCode === 1) {
              var schedule = result.data.provideDeliveryTimingCustomer;

              for (var i = 0; i < schedule.length; i++) {
                this.deliverySchedules.push({
                  text:
                    schedule[i].name +
                    " (" +
                    schedule[i].start_time +
                    " to " +
                    schedule[i].end_time +
                    ")",
                  value: schedule[i].d_s_id
                });
              }
            } else if (result.data.successCode === 0) {
              console.log("result", result);
            } else if (
              result.data.successCode === 0 &&
              result.data.messageCode === 1053
            ) {
              localStorage.clear();
              this.$router.replace({ name: "register" });
            }
          })
          .catch(error => {
            return;
          });
      }
    },
    getDetails() {
      if (!localStorage.getItem("token")) {
        var requestData = {
          user_type: "guest",
          vendor_id: localStorage.getItem("vendorId"),
          product: localStorage.getItem("productId"),
          type: "Product"
        };
      } else {
        var requestData = {
          user_id: localStorage.getItem("userId"),
          token: localStorage.getItem("token"),
          vendor_id: localStorage.getItem("vendorId"),
          product: localStorage.getItem("productId"),
          type: "Product"
        };
      }

      this.isLoading = true;
      getProductDetail(requestData)
        .then(result => {
          if (result.data.successCode === 1) {
            this.details = result.data.allCategoryProductsList[0];
            // console.log("*", result);
          } else if (
            result.data.successCode === 0 &&
            result.data.messageCode === 1053
          ) {
            localStorage.clear();
            this.$router.replace({ name: "register" });
            this.isLoading = false;
          }
        })
        .catch(error => {
          this.isLoading = false;
          return;
        });
    },
    getAddressInfo() {
      var requestData = {
        user_id: localStorage.getItem("userId"),
        token: localStorage.getItem("token"),
        vendor_id: localStorage.getItem("vendorId")
      };

      getBalanceAndDeliveryInfo(requestData)
        .then(result => {
          if (result.data.successCode === 1) {
            this.addresses = result.data.addresses;
            // console.log("result", this.addresses);
            // for (var i = 0; i < this.addresses.length; i++) {
            //   this.deliveryAddress.push({
            //     text:
            //       this.addresses[i].address.address +
            //       "," +
            //       this.addresses[i].address.location,
            //     value: this.addresses[i].id
            //   });
            // }

            // this.delivery_id = result.data.deliver_schdule_id;
            // this.orderChangeDate = result.data.edit__order_time;
            // this.amountBilled = result.data.subscriptionOrderTotalPrice;
            // this.nextDeliveryDate =
            //   result.data.willDeliver +
            //   " " +
            //   result.data.subscriptionItems[0].between;
            // this.subscribedItems = result.data.subscriptionItems;
          } else if (
            result.data.successCode === 0 &&
            result.data.messageCode === 1053
          ) {
            localStorage.clear();
            this.$router.replace({ name: "register" });
          }
        })
        .catch(error => {
          return;
        });
    },
    openPicker() {
      this.$refs.programaticOpen.showCalendar();
    },
    increment() {
      this.quantity++;
    },
    decrement() {
      if (this.quantity === 0) {
        // alert("Negative quantity not allowed");
      } else {
        this.quantity--;
      }
    },
    getDeliveryChargesDetails() {
      if (!localStorage.getItem("userName")) {
        localStorage.clear();
        this.$router.push({ name: "register" });
      } else {
        var requestData = {
          user_id: localStorage.getItem("userId"),
          token: localStorage.getItem("token"),
          type: "0",
          vendor_id: localStorage.getItem("vendorId")
        };

        getDeliveryChargeInfo(requestData)
          .then(result => {
            if (result.data.successCode === 1) {
              console.log("####", result);
            } else if (
              result.data.successCode === 0 &&
              result.data.messageCode === 1053
            ) {
              localStorage.clear();
              this.$router.replace({ name: "register" });
            }
          })
          .catch(error => {
            return;
          });
      }
    },
    getDuration() {
      if (!localStorage.getItem("userName")) {
        localStorage.clear();
        this.$router.push({ name: "register" });
      } else {
        var requestData = {
          user_id: localStorage.getItem("userId"),
          vendor_id: localStorage.getItem("vendorId"),
          token: localStorage.getItem("token")
        };
        getDeliveryDuration(requestData)
          .then(result => {
            if (result.data.successCode === 1) {
              this.daysDetails = result.data.data;
              // console.log(this.daysDetails);
              for (var i = 0; i < this.daysDetails.length; i++) {
                var dayName = "";
                if (this.daysDetails[i].name == "Day") {
                  dayName = "Delivery";
                } else {
                  dayName = "Deliveries";
                }
                this.getDeliveries.push({
                  text: this.daysDetails[i].duration + " " + dayName,
                  value: this.daysDetails[i].id
                });
              }
            } else if (
              result.data.successCode === 0 &&
              result.data.messageCode === 1053
            ) {
              localStorage.clear();
              this.$router.replace({ name: "register" });
            }
          })
          .catch(error => {
            return;
          });
      }
    }
  }
};
</script>
